<div class="grid" style="height: 100%;">
  <div class="responsive-div-iframe py-2" *ngIf="pluginFacebookAfficher">
    <iframe title="Facebook Garage de Montplaisir Maubeuge" #iFrameFacebook [src]="source"
      class="responsive-iframe"></iframe>
  </div>
  <div class="col">
    <app-header class="grid justify-content-center p-nogutter header"></app-header>


    <div class="grid w-100 text-right m-2" *ngIf="!pluginFacebookAfficher">
      <button pButton type="button" class="button-fcb mr-1" icon="fab fa-facebook-f" (click)="openFacebook()"
        label="Ouvrir"></button>
      <iframe title="Mini Facebook Garage de Montplaisir Maubeuge" #iFrameFacebookMiniGarageMontplaisir
        src="https://www.facebook.com/plugins/like.php?href=https%3A%2F%2Fwww.facebook.com%2FGarage-de-Montplaisir-175600499270754%2F&width=211&layout=button_count&action=like&size=large&share=true&height=46&appId=1320316631741142"
        width="200" height="46" style="border:none;overflow:hidden" scrolling="no" frameborder="0" data-lazy="true"
        allowfullscreen="true"
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
      <!-- <button pButton type="button" class="button-fcb"
        (onClick)="goToLink('https://www.facebook.com/Garage-de-Montplaisir-175600499270754/')" label="Ouvrir"></button> -->

    </div>

    <div class="grid mx-2">
      <div class="col-12 p-3">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </div>
      <button pButton pRipple type="button" icon="fas fa-store-alt" label="Catalogue"
        class="p-button-rounded p-button-catalogue" [routerLink]="['/catalogue']"
        routerLinkActive="router-link-active"></button>

      <button pButton pRipple type="button" icon="fas fa-envelope" label="Contactez-nous"
        class="p-button-rounded p-button-contact top-50" (click)="showDialogContact()"></button>

    </div>

    <!-- <div class="grid justify-content-center mt-3">
      <iframe class="maps-iframe" #iFrameGMaps id="iFrameGMaps"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10201.110319456107!2d3.931718799999992!3d50.268075500000016!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x251ee895a8ab79b5!2sGarage%20de%20MontPlaisir!5e0!3m2!1sfr!2sfr!4v1642628985394!5m2!1sfr!2sfr"
        width="{{getWidth}}" height="{{height}}" style="border:0;" allowfullscreen="" loading="lazy">
      </iframe>
    </div> -->
    <div class="mapouter grid justify-content-center mt-3">
      <div class="gmap_canvas"><iframe width="{{getWidth}}" height="{{height}}" id="iFrameGMaps"
          src="https://maps.google.com/maps?q=151%20rue%20de%20montplaisir&t=&z=17&ie=UTF8&iwloc=&output=embed"
          frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe><br>
        <a href="https://www.embedgooglemap.net"></a>
      </div>
    </div>
  </div>
</div>

<app-footer [isMobile]="isMobile"></app-footer>


<p-dialog header="Contactez-nous" [(visible)]="displayContactDialog">
  <div class="register-form">
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <div class="grid">
        <div class="form-group col">
          <label for="float-input-invalid">Nom</label>
          <input id="float-input-invalid" type="text" formControlName="nom" class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f['nom'].errors }" />
          <div *ngIf="submitted && f['nom'].errors" class="invalid-feedback">
            <div *ngIf="f['nom'].errors['required']">Le nom est obligatoire.</div>
          </div>
        </div>
        <div class="form-group col">
          <label>Email</label>
          <input type="text" formControlName="email" class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" />
          <div *ngIf="submitted && f['email'].errors" class="invalid-feedback">
            <div *ngIf="f['email'].errors['required']">L'email est obligatoire.</div>
            <div *ngIf="f['email'].errors['email']">l'email est incorrect.</div>
          </div>
        </div>
      </div>

      <div class="form-group mt-2">
        <label for="float-input-invalid">Sujet</label>
        <input id="float-input-invalid" type="text" formControlName="sujet" class="form-control"
          [ngClass]="{ 'is-invalid': submitted && f['sujet'].errors }" />
        <div *ngIf="submitted && f['sujet'].errors" class="invalid-feedback">
          <div *ngIf="f['sujet'].errors['required']">Le sujet est obligatoire.</div>
        </div>
      </div>

      <div class="form-group mt-2">
        <label>Message</label>
        <textarea rows="5" cols="30" pInputTextarea formControlName="message" autoResize="autoResize"
          class="form-control" [ngClass]="{ 'is-invalid': submitted && f['message'].errors }"></textarea>
        <div *ngIf="submitted && f['message'].errors" class="invalid-feedback">
          <div *ngIf="f['message'].errors['required']">Le message est obligatoire.</div>
          <div *ngIf="f['message'].errors['minlength']">
            Le message doit être plus long.
          </div>
        </div>
      </div>

      <div class="form-group mt-3">
        <button type="submit" class="btn btn-primary mr-2">Envoyer</button>
        <button type="button" (click)="onReset()" class="btn btn-warning float-right">
          Reset
        </button>
      </div>
    </form>
  </div>
</p-dialog>